import { useEffect, useRef } from "react";

type Handler = () => void;

/**
 * Android 뒤로가기 버튼 이벤트를 처리하는 훅
 * @param callback 뒤로가기 버튼 이벤트 처리 콜백
 */
export function useAndroidBackHandler(callback: Handler) {
  const handlerRef = useRef<Handler>(() => {});

  useEffect(() => {
    handlerRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const listener = () => {
      handlerRef.current();
    };
    
    window.addEventListener("androidBackButtonPressed", listener);
    return () => {
      window.removeEventListener("androidBackButtonPressed", listener);
    };
  }, []);
}